import React from 'react';
import ImportModal from '../common/ImportModal';
import { useTranslation } from 'react-i18next';

const ProductSizeImportModal = ({
  isOpen,
  onClose,
  onImport,
  importing = false,
  importError = null,
  importSuccess = false,
}) => {
  const { t } = useTranslation();

  // Per-column guidance for the template's "Instructions" sheet.
  const NOTES = t('importTemplate.notes', { returnObjects: true });
  // Mirrors product_size.py's importer exactly. current_stock / minimum_stock were
  // in the template but are never read on import — stock is set through the inventory
  // screens — so they only misled people into filling them.
  const TEMPLATE_HEADERS = [
    'alias_name',
    'product_category_name',
    'product_catalogue_name',
    'product_size',
    'product_weight',
    'standard_length',
    'product_thickness',
    'price',
    'coil_tracked',
  ];

  const TEMPLATE_COLUMN_SPECS = {
    alias_name: { required: true, example: 'AMNS 0.50X1220 BLUE' },
    product_category_name: { required: true, note: NOTES.matchCategory, example: 'Colour' },
    product_catalogue_name: { required: true, note: NOTES.matchSubCategory, example: 'Colour Coils' },
    // Optional in the importer, despite previously being marked required here.
    product_size: { required: false, example: '0.50MM X 1220' },
    product_weight: { required: false, note: NOTES.weightKgPerPiece, example: '10000' },
    standard_length: { required: false, note: NOTES.standardLengthM, example: '' },
    product_thickness: { required: false, example: '0.5' },
    // Per-SKU price (migration 061). Optional — blank leaves the SKU unpriced.
    price: { required: false, example: '50.00' },
    // Stock for these is held coil by coil rather than as one balance. Importable so a
    // coil business can bring its whole catalogue in already ticked, instead of opening
    // every product afterwards — which is how it ends up half-applied.
    coil_tracked: { required: false, allowed: ['TRUE', 'FALSE'], note: NOTES.coilTracked, example: 'TRUE' },
  };

  const importConfig = t('productSizes.import.config', { returnObjects: true });

  return (
    <ImportModal
      isOpen={isOpen}
      onClose={onClose}
      onImport={onImport}
      importing={importing}
      importError={importError}
      importSuccess={importSuccess}
      templateHeaders={TEMPLATE_HEADERS}
      templateColumnSpecs={TEMPLATE_COLUMN_SPECS}
      templateFilename={importConfig.templateFilename}
      inputId={importConfig.inputId}
      skipHeaderValidation={true}
    />
  );
}; 

export default ProductSizeImportModal;